import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from "../apiBase";
import { ownerSecretHeader } from "../ownerSecret";

export const EditWtbalPage = ({ wtbalToEdit, currentAircraft }) => {
  const tail = currentAircraft?.tailNumber || "";
    const navigate = useNavigate();

    const [weight, setWeight] = useState(String(wtbalToEdit?.Weight ?? ""));
    const [arm, setArm] = useState(String(wtbalToEdit?.Arm ?? ""));

    useEffect(() => {
        if (wtbalToEdit) {
            setWeight(String(wtbalToEdit.Weight ?? ""));
            setArm(String(wtbalToEdit.Arm ?? ""));
        }
    }, [wtbalToEdit]);

    const editWtbal = async () => {
        const id = wtbalToEdit.id || wtbalToEdit._id;
        if (!id) {
            alert("EditWtbalPage: No station id found to edit.");
            return;
            }

        const url = `${API_BASE}/api/wtbals?tail=${encodeURIComponent(tail)}&id=${encodeURIComponent(id)}`;

        const wNum = Number(weight);
        const aNum = Number(arm);

        if (!Number.isFinite(wNum) || !Number.isFinite(aNum)) {
        alert("EditWtbalPage: Weight and Arm must be valid numbers.");
        return;
        }

        const editedWtbal = {
            Weight: Number(weight),
            Arm: Number(arm),
        };

        try {
            const response = await fetch(url, {
                method: 'PUT',
                body: JSON.stringify(editedWtbal),
                headers: {
                    'Content-Type': 'application/json',
                    ...ownerSecretHeader(tail),
                },
            });

            if (response.ok) {
            alert("EditWtbalPage: Successfully edited the weight and balance");
            navigate("/wtbals");
        } else if (response.status === 403) {
            alert("You're not authorized to edit this aircraft's weight and balance data.");
        } else {
            alert(`EditWtbalPage: Failed to edit weight and balance, status code = ${response.status}`);
        }
        } catch (error) {
            alert("EditWtbalPage: An error occurred while editing the weight and balance.");
        }
    };

    if (!wtbalToEdit) {
            return <div>No station selected.</div>;
        }

    return (
        <div>
        <p>Edit Weight and Balance Station</p>

        <table id="edit-wtbals">
            <thead>
                <tr>
                    <th className='station_box'>Station</th>
                    <th className='weight_box'>Weight (lbs)</th>
                    <th className='arm_box'>Arm (in)</th>
                </tr>
            </thead>
            <tbody>
                    <tr>
                        <td className='station_box'>{wtbalToEdit.id}</td>
                        <td className='weight_box'>
                            <input type="text" value={weight} onChange={e => setWeight(e.target.value)}
                                style={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", width: "90%" }} />
                        </td>
                        <td className='arm_box'>
                            <input type="text" value={arm} onChange={e => setArm(e.target.value)}
                                style={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", width: "90%" }} />
                        </td>
                       </tr>
                </tbody>
            </table>
            <button onClick={editWtbal}>Save</button>
        </div>
    );
}

export default EditWtbalPage;